import { render, staticRenderFns } from "./Divide.vue?vue&type=template&id=63adaff6&scoped=true&"
import script from "./Divide.vue?vue&type=script&lang=js&"
export * from "./Divide.vue?vue&type=script&lang=js&"
import style0 from "./Divide.vue?vue&type=style&index=0&id=63adaff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63adaff6",
  null
  
)

export default component.exports